import { PostItemProps } from "apis";
import { lazy } from "react";

export const PageAdminPost = lazy(() => import("./List"));
export const PageAdminPostCreate = lazy(() => import("./Add"));
export const PageAdminPostUpdate = lazy(() => import("./Edit"));

export interface FormPostValuesProps extends PostItemProps {
    topicId?: number;
    topicIds?: string[]
}
export interface FormSearchPostValuesProps {
    q?: string;
    topicIds?: string[],
    publish?: "0" | "1"
}